<template>
    <index-table
        :cols="[
            {
                value: 'model_name',
                label: 'Type',
                sortable: true,
                searchable: true,
            },
            {
                value: 'attribute',
                label: 'Attribute',
                sortable: true,
                searchable: true,
                customCell: 'ActionAttributeTableCell',
            },
            {
                value: 'action',
                label: 'Action',
                sortable: true,
                searchable: true,
            },
            {
                value: 'user',
                label: 'User',
                sortable: true,
                searchable: true,
                customCell: 'ActionEmailTableCell',
            },
            {
                value: 'created_at',
                label: 'When',
                sortable: true,
                searchable: true,
                filter: 'whenFromNow',
            },
        ]"
        :title="'Actions'"
        :model="'actions'"
        :defaultSort="defaultSort"
        :defaultDir="defaultDir"
        data-test-id="actions-table"
    >
        <template #disclaimer>
            <p class="disclaimer">Actions originating from Smart Devices have blank users</p>
        </template>
    </index-table>
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import SortDirections from '@/constants/sort-directions'

export default {
    components: {
        IndexTable,
    },

    data() {
        return {
            defaultSort: 'created_at',
            defaultDir: SortDirections.DESC,
        }
    },
}
</script>
